import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { CryptoService } from '../../shared/services/crypto.service';

@Component({
    selector: 'app-reset-password-link',
    templateUrl: './reset-password-link.component.html',
    styleUrls: ['./reset-password-link.component.scss'],
    standalone: false
})
export class ResetPasswordLinkComponent implements OnInit {
    private email: string;

    constructor(
        private router: Router,
        private location: Location,
        private route: ActivatedRoute,
        private cryptoService: CryptoService) { }

    goBack(): void {
        this.location.back();
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            const encryptedEmail = params['email'];
            if (encryptedEmail) {
                this.email = this.cryptoService.decryptData(encryptedEmail);
            }
        });
    }

    onResendLink(): void {
        this.router.navigate(['/forgot-password']);
    }

    openEmailApp(): void {
        window.location.href = `mailto:${this.email}`;
    }
}